class PackSelectorComponent extends HTMLElement {
  #multiplier = 1;
  #formElement = null;
  #quantityInput = null;
  #onFlavorChanged = () => this.#initialize();

  #onResyncDropdown = () => {
    const options = [...this.querySelectorAll('.pack-option')];
    const active = options.findIndex(o => o.classList.contains('pack-option--active'));
    if (active >= 0) this.#syncDropdown(active);
  };

  connectedCallback() {
    this.#formElement = this.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]') ?? null;
    if (this.#formElement) {
      this.#quantityInput = document.createElement('input');
      this.#quantityInput.type = 'hidden';
      this.#quantityInput.name = 'quantity';
      this.#formElement.appendChild(this.#quantityInput);
    }

    this.#initialize();
    document.addEventListener('flavor:changed', this.#onFlavorChanged);
    document.addEventListener('pack:resync-dropdown', this.#onResyncDropdown);
  }

  disconnectedCallback() {
    document.removeEventListener('flavor:changed', this.#onFlavorChanged);
    document.removeEventListener('pack:resync-dropdown', this.#onResyncDropdown);

    this.querySelectorAll('.pack-option').forEach((option) => {
      option.removeEventListener('click', this.#onOptionClick);
    });

    if (this.#quantityInput) {
      this.#quantityInput.remove();
      this.#quantityInput = null;
    }
  }

  #initialize() {
    this.querySelectorAll('.pack-option').forEach((option) => {
      option.removeEventListener('click', this.#onOptionClick);
      option.addEventListener('click', this.#onOptionClick);
    });

    const options = this.querySelectorAll('.pack-option');
    options.forEach((o) => o.classList.remove('pack-option--active'));

    const first = options[0];
    if (first) {
      first.classList.add('pack-option--active');
      this.#multiplier = parseInt(first.dataset.multiplier, 10) || 1;
    } else {
      this.#multiplier = 1;
    }

    this.#ensureQuantityInput();
    if (this.#quantityInput) {
      this.#quantityInput.value = String(this.#multiplier);
    }

    this.#waitForDropdownAndSync(0);

    if (first) {
      this.#dispatchPackChanged(first);
    }
  }

  #dispatchPackChanged(option) {
    document.dispatchEvent(new CustomEvent('pack:changed', {
      detail: {
        multiplier: parseInt(option.dataset.multiplier, 10) || 1,
        onetimeDiscount: parseFloat(option.dataset.onetimeDiscount) || 0,
        subDiscount: parseFloat(option.dataset.subDiscount) || 0
      }
    }));
  }

  #ensureQuantityInput() {
    if (this.#quantityInput && this.#quantityInput.isConnected) return;

    this.#formElement = this.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]') ?? null;
    if (this.#formElement) {
      this.#quantityInput = document.createElement('input');
      this.#quantityInput.type = 'hidden';
      this.#quantityInput.name = 'quantity';
      this.#formElement.appendChild(this.#quantityInput);
    }
  }

  #onOptionClick = (event) => {
    const option = event.currentTarget;
    const options = this.querySelectorAll('.pack-option');
    options.forEach((o) => o.classList.remove('pack-option--active'));
    option.classList.add('pack-option--active');
    this.#multiplier = parseInt(option.dataset.multiplier, 10) || 1;
    if (this.#quantityInput) {
      this.#quantityInput.value = String(this.#multiplier);
    }

    const allOptions = [...options];
    const index = allOptions.indexOf(option);
    this.#syncDropdown(index);
    this.#dispatchPackChanged(option);
  };

  #isSubscriptionActive() {
    const subRadio = document.querySelector('input#purchaseTypeSubscription, input[value="purchaseTypeSubscription"]');
    return subRadio ? subRadio.checked : true;
  }

  #syncDropdown(index) {
    const dropdown = document.querySelector('.stayai-subscription-dropdown');
    if (dropdown && index >= 0 && index < dropdown.options.length) {
      if (dropdown.selectedIndex === index) return;
      dropdown.selectedIndex = index;
      if (this.#isSubscriptionActive()) {
        try {
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (_) {
          // External Stay AI script (buy-box-extended.js) may throw when
          // it tries to read a price element that doesn't exist on this theme.
        }
      }
    }
  }

  #waitForDropdownAndSync(index, attempts = 0) {
    const dropdown = document.querySelector('.stayai-subscription-dropdown');
    if (dropdown) {
      this.#syncDropdown(index);
      return;
    }
    if (attempts < 20) {
      setTimeout(() => this.#waitForDropdownAndSync(index, attempts + 1), 300);
    }
  }
}

if (!customElements.get('pack-selector-component')) {
  customElements.define('pack-selector-component', PackSelectorComponent);
}
